import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash.get';
import { Box, Button, FlexBox, FormDialog, Grid, InputField } from '@kis-technologies/kis-ui';
import { useActions } from 'hooks/useActions';
import { actions as mediaActions, selectors as mediaSelectors } from 'store/media';
import { isValidVideo } from 'utils/validation';
import { MediaTypes } from 'views/MediaCenterView/types';
import Requirements from './Requirements';
import { useStyles } from '../styled';
import { ManageVideoOverlayProps } from '../types';
import { getMediaTypeLabel } from '../utils';

const ManageVideoOverlay = (props: ManageVideoOverlayProps) => {
  const { action, configuration, onClose } = props;

  const [createMedia] = useActions([mediaActions.createMedia]);

  const { pending } = useSelector(mediaSelectors.selectAction);
  const attractMediaList = useSelector(mediaSelectors.selectAttractImages);

  const mediaRecord = get(attractMediaList, '[0]');

  const fileRef = useRef<HTMLInputElement>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>();
  const [selectedFileName, setSelectedFileName] = useState<string>(mediaRecord ? mediaRecord.name : '');
  const [error, setError] = useState<string | null>(null);

  const classes = useStyles({ genreTab: false })();

  const mediaLabel = getMediaTypeLabel(MediaTypes.ATTRACT_VIDEO);

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const validationErr = isValidVideo(file);
    if (validationErr) {
      setError(validationErr);
      return;
    }
    setError(null);
    setSelectedFile(file);
    setSelectedFileName(file.name);
  };

  const onSaveClick = () => {
    if (!selectedFile) return;

    createMedia({
      configurationId: configuration.id,
      file: selectedFile,
      type: MediaTypes.ATTRACT_VIDEO
    });
  };

  return (
    <FormDialog
      cancelButtonAction={onClose}
      cancelButtonText="Cancel"
      confirmButtonAction={onSaveClick}
      confirmButtonDisabled={!selectedFile}
      confirmButtonIsLoading={pending}
      confirmButtonText="Save"
      open
      title={`${action} ${mediaLabel}`}
    >
      <Grid>
        <input type="file" ref={fileRef} style={{ display: 'none' }} accept=".mp4,.mov" onChange={handleFileSelect} />
        <FlexBox gap="16px">
          <Box className={classes.overlayFieldBox}>
            <InputField
              data-testid="filename-input-field"
              error={error !== null}
              helperText={error}
              label="Video"
              readOnly
              size="small"
              sx={{ width: '262px' }}
              value={selectedFileName}
            />
          </Box>
          <Button customSize="small" width={200} onClick={() => fileRef.current?.click()} sx={{ marginTop: '33px' }}>
            Select Video
          </Button>
        </FlexBox>
        <Requirements mediaType={MediaTypes.ATTRACT_VIDEO} />
      </Grid>
    </FormDialog>
  );
};

export default ManageVideoOverlay;
